
export const CONSTANT = {
  AUTH: {
    APP_NAME: 'Template.io',
    AUTH_REQ: "Authentication required. Please log in.",
    ERROR_FETCHING: "Error fetching data:",
    LOADING: "Loading...",
    NO_DATA_FOUND: "No data found",
  },

  USER: {
    LOADING_EMPLOYEE: "Loading employee...",
    NO_EMPLOYEE_FOUND: "No employee found",
  },

  EMAIL_TEMPLATE: {
    LOADING_TEMPLATES: "Loading email templates...",
    NO_EMAIL_TEMPLATE_FOUND: "No email templates found",
  },

  TEMPLATE: {
    LOADING_TEMPLATE: "Loading templates...",
    NO_TEMPLATE_FOUND: "No templates found",
  },

  COMPANIES: {
    LOADING_COMPANIES_DETAILS: "Loading companies details...",
    LOADING_COMPANIES: "Loading companies...",
    NO_COMPANIES_FOUND: "No companies found",
    NO_PENDING_REQUEST: "No pending requests found",
  },

  PERMISSION: {
    LOADING_PERMISSION: "Loading permission...",
    NO_PERMISSION_FOUND: "No permission found",
  },

  INBOX: {
    LOADING_INBOX: "Loading inbox...",
    NO_INBOX_FOUND: "Empty inbox",
  },

};
